import { coreApi } from '../api'

export interface CounterResponse {
  assignments: number
  assignmentsAndUnassignments: number
}

async function fetchData(): Promise<CounterResponse> {
  const response = await coreApi.get<CounterResponse>(
    '/sales-engagement/auto-refi/assignments/count',
  )
  return response.data
}

export { fetchData }
